require('./assets/css/entry.scss')
//require('jquery/dist/jquery.js')
//require('bootstrap/dist/js/bootstrap.js')
require('bugsnag-js')
require('./client.js')


// WEBPACK FOOTER //
// ./src/client/entry.js